export const colorString = 'color';
export const mileRadiusString = 'mileradius';
export const modelId = 'modelid';
export const dealerString = 'dealer';
export const familyString = 'family';
export const vinStatus = 'vinstatus';
export const segmentString = 'segment';
export const categoryString = 'category';
export const searchRangeString = 'searchrange';
export const MODULE_NAME = 'inventory near you';
